export type ConsentDecision = "GRANTED" | "DENIED";

export const ANALYTICS_CONSENT_EVENT = "analytics-consent-change";

export const dispatchConsentChange = (decision: ConsentDecision): void => {
  window.dispatchEvent(
    new CustomEvent<boolean>(ANALYTICS_CONSENT_EVENT, {
      detail: decision === "GRANTED",
    }),
  );
};
